module.exports = __webpack_public_path__ + "img/pro-p-slider5.8ad62f05.png";